import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SalesReportPageRoutingModule } from './sales-report-routing.module';

import { SalesReportPage } from './sales-report.page';

//import { IonicPageModule } from '@ionic/angular';
import { NgChartsModule } from 'ng2-charts';

import { SharedModule } from '../../shared.module';
import { StylistPickerModule } from '../../components/stylist-picker/stylist-picker.module';
import { SalonMonsterLoadMaskModule } from '../../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../../components/smr-tap-retry/smr-tap-retry.module';
import { SalonMonsterDatePickerModule } from '../../components/smr-date-picker/smr-date-picker.module';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SalesReportPageRoutingModule,
    NgChartsModule,
    StylistPickerModule,
    SalonMonsterLoadMaskModule,
    SalonMonsterTapRetryModule,
    SalonMonsterDatePickerModule,
    SharedModule,
    NgxDatatableModule,
    TableModule,
    ButtonModule,
  ],
  declarations: [SalesReportPage],
})
export class SalesReportPageModule {}
